import React from "react";
import {BaseInput} from "../BaseInput";

interface SearchBarProps {
  placeholder: string;
  value: string;
  onChangeValue: (value: string) => void;
}

export const SearchBar = ({
  placeholder,
  value,
  onChangeValue
}: SearchBarProps) => (
  <BaseInput
    onChange={(e) => onChangeValue(e.target.value)}
    value={value}
    placeholder={placeholder}
  />
)